import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WhatIsGtbuySpreadsheet from "../pages/articles/WhatIsGtbuySpreadsheet";
import GtbuySpreadsheetGuide from "../pages/articles/GtbuySpreadsheetGuide";
import KakobuySpreadsheetGuide from "../pages/articles/KakobuySpreadsheetGuide";
import SuperbuySpreadsheetGuide from "../pages/articles/SuperbuySpreadsheetGuide";
import SpreadsheetComparison from "../pages/articles/SpreadsheetComparison";
import SpreadsheetSafety from "../pages/articles/SpreadsheetSafety";
import BestGtbuySpreadsheetSources from "../pages/articles/BestGtbuySpreadsheetSources";
import FreeGtbuySpreadsheetList from "../pages/articles/FreeGtbuySpreadsheetList";
import PremiumSpreadsheetTools from "../pages/articles/PremiumSpreadsheetTools";
import SpreadsheetUpdateFrequency from "../pages/articles/SpreadsheetUpdateFrequency";
import VerifiedSpreadsheetDatabase from "../pages/articles/VerifiedSpreadsheetDatabase";
import GtbuyVsKakobuy from "../pages/articles/GtbuyVsKakobuy";
import SuperbuyVsGtbuy from "../pages/articles/SuperbuyVsGtbuy";
import GtbuySpreadsheetList2026 from "../pages/articles/GtbuySpreadsheetList2026";
import SpreadsheetBeginnersGuide from "../pages/articles/SpreadsheetBeginnersGuide";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-gtbuy-spreadsheet",
    element: <WhatIsGtbuySpreadsheet />,
  },
  {
    path: "/gtbuy-spreadsheet-guide",
    element: <GtbuySpreadsheetGuide />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <KakobuySpreadsheetGuide />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <SuperbuySpreadsheetGuide />,
  },
  {
    path: "/spreadsheet-comparison",
    element: <SpreadsheetComparison />,
  },
  {
    path: "/spreadsheet-safety",
    element: <SpreadsheetSafety />,
  },
  {
    path: "/best-gtbuy-spreadsheet-sources",
    element: <BestGtbuySpreadsheetSources />,
  },
  {
    path: "/free-gtbuy-spreadsheet-list",
    element: <FreeGtbuySpreadsheetList />,
  },
  {
    path: "/premium-spreadsheet-tools",
    element: <PremiumSpreadsheetTools />,
  },
  {
    path: "/spreadsheet-update-frequency",
    element: <SpreadsheetUpdateFrequency />,
  },
  {
    path: "/verified-spreadsheet-database",
    element: <VerifiedSpreadsheetDatabase />,
  },
  {
    path: "/gtbuy-vs-kakobuy",
    element: <GtbuyVsKakobuy />,
  },
  {
    path: "/superbuy-vs-gtbuy",
    element: <SuperbuyVsGtbuy />,
  },
  {
    path: "/gtbuy-spreadsheet-list-2026",
    element: <GtbuySpreadsheetList2026 />,
  },
  {
    path: "/spreadsheet-beginners-guide",
    element: <SpreadsheetBeginnersGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;